//import React from "react";
import React, { useEffect, useState, } from "react";
import { useHistory } from "react-router-dom";
import Admin from "layouts/Admin";
import Footer from "components/Footer/Footer";

// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  Table,
  DropdownButton,
  Dropdown,
  FormControl,
} from "react-bootstrap";
import { createPrinter } from "typescript";

import firebase from "../firebase";

const retreivedrivers=()=> {

  let history = useHistory();
  
//Stroring Reteriwing Data
const[userData,setUserData]= useState([]);

useEffect(()=>{

  const files = firebase.database().ref("StaffDriver").orderByChild("Status").equalTo(1);
  files.on('value', (snapshot)=>{
    const userList = snapshot.val();
    const dataList = [];
    for(let id in userList){
      dataList.push({id,...userList[id]});
    }
    setUserData(dataList);
    console.log(dataList);
  }) 
    
},[]);


// const updateButtoclk = (data) => {
//   let indi = true;

//   history.push({pathname:'/admin/UpdateAccDetails', state:data});
// }
    
const deleteData = (id) =>{
  const delRef = firebase.database().ref("StaffDriver").child(id);
  delRef.remove();
  alert("Succfully Deleted");
}

const filterData=(datas,searchKey)=>{

  const result = datas.filter(
    (data)=>
    data.NIC.toLowerCase().includes(searchKey) ||
    data.Age.toLowerCase().includes(searchKey)
     //Searching via 
  );
  setUserData(result);
}



const handleInput=(e)=>{
  const searchKey = e.currentTarget.value;

  const files = firebase.database().ref("").orderByChild("Status").equalTo(1);;
  files.on('value', (snapshot)=>{
    const userList = snapshot.val();
    const dataList = [];
    for(let id in userList){
      dataList.push({id,...userList[id]});
    }
    //
    filterData(dataList, searchKey);
  }) 
    

}
  return (
    <>

    
<Admin/>

<br/>

<Container>
  <Row>
    <Col md={{ span: 12, offset: 1 }}>  




    <Container fluid>
{/* <FormControl
    type="search"
    placeholder="Search by NIC" 
    className="mr-2"
    aria-label="Search"
    name="searchQuery"
    onChange={handleInput}
  /> */}
 <br/>
        <Table className = "text-center" striped bordered hover>
        <thead>
            <tr>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Phone Number</th>
            
            </tr>
        </thead>
        <tbody>{userData.map((data, index)=>(
            <tr>
            <td>{data.FName}</td>
            <td>{data.LName}</td>
            <td>{data.Phone}</td>
            
    
            <center>
            {/* <Button onClick={()=>Changestatus(data.id,1)}  className = "mx-2" variant="primary" size="" active>
              Activate
            </Button>{' '}
            <Button onClick={()=>Changestatus(data.id,0)} className = "ml-2 mr-0" variant="primary" size="" active>
              Deactivate 
            </Button> */}

            <Button href={`/assigncompanyupdate/${data.id}`} className = "mx-2" variant="primary" size="" active>
              assign a company
            </Button>{' '}
           
            </center>

            </tr>
            ))}
        </tbody>
        </Table>
        </Container>


            
      </Col>
  </Row>
</Container>

<Footer /> 
        </>

        ) ;
    }
export default retreivedrivers;